import { render, staticRenderFns } from "./TransactionAttachmentList.vue?vue&type=template&id=06b32444&scoped=true&"
import script from "./TransactionAttachmentList.vue?vue&type=script&lang=js&"
export * from "./TransactionAttachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b32444",
  null
  
)

export default component.exports